import Vue from 'vue'
import Storages from 'js-storage'

Object.defineProperty(Vue.prototype, '$storage', { value: Storages })
